import React from "react";
import { usePreferences, useMoneyFormat } from "../Context/PreferencesContext";
import { shouldAccentNegative } from "../utils/formatters";

// Reusable across every report family. Driven by the envelope's summary block.
export default function ReportSummaryStrip({ summary = [] }) {
   const { prefs } = usePreferences();
   const fmtMoney = useMoneyFormat();
   const fmt = (item) =>
      item.type === "money" ? fmtMoney(Number(item.value || 0)) : Number(item.value || 0).toLocaleString();
   return (
      <div className="d-flex gap-4 py-3 px-1 border-bottom" style={{ fontSize: 14 }}>
         {summary.map((item) => {
            const negative = item.type === "money" && shouldAccentNegative(Number(item.value), prefs.money);
            return (
               <div key={item.key} className="d-flex flex-column">
                  <span style={{ fontSize: 13, fontWeight: 400, color: "#6c757d" }}>{item.label}</span>
                  <span style={{ fontSize: 20, fontWeight: 600, color: negative ? "#dc3545" : "#000",
                                 fontVariantNumeric: "tabular-nums" }}>{fmt(item)}</span>
               </div>
            );
         })}
      </div>
   );
}
